<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Beszállítói visszáruk</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/processes/supplier-return-orders/add')"
        icon="el-icon-plus"
        v-can="'supplierreturnorder.create'"
      >
        Új beszállítói visszáru
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="supplierReturnOrder/fetchAll"
      />
    </div>
    <supplier-return-order-list/>
    <template v-if="$route.meta.showAddSupplierReturnOrderDialog">
      <supplier-return-order-dialog
        type="add"
        :supplier-return-order-id="$route.params.id"
      />
    </template>
    <template v-if="$route.meta.showUpdateSupplierReturnOrderDialog">
      <supplier-return-order-dialog
        :supplier-return-order-id="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showSupplierReturnOrderViewDialog">
      <supplier-return-order-dialog
        :supplier-return-order-id="$route.params.id"
        type="view"
      />
    </template>
  </el-card>
</template>

<script>
import SupplierReturnOrderList from '../../components/processes/supplierReturnOrders/List';
import SupplierReturnOrderDialog from '../../components/processes/supplierReturnOrders/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    SupplierReturnOrderList,
    SupplierReturnOrderDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      let storages = this.$store.getters['storage/storages'];
      if (!storages.length) {
        await this.$store.dispatch('storage/fetchAll');
        storages = this.$store.getters['storage/storages'];
      }
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'text',
          name: 'cm_delivery_note_number',
          label: 'CM szlev száma',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
            {
              label: 'Kész',
              status: 'done'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'remote',
          name: 'supplier_id',
          label: 'Beszállító',
          labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/search',
        },
        {
          type: 'select',
          options: storages,
          name: 'storage_id',
          label: 'Raktár',
          labelCallback: storage => storage && storage.name || '',
          valueKey: 'id',
        },
      ];
    },
  },
};
</script>
